
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchWithRefreshRestau } from '../../components/types/types';

interface ProtectedRoadRestoProps {
    children: React.ReactNode;
}

const ProtectedRoadResto: React.FC<ProtectedRoadRestoProps> = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
    useEffect(() => {
        const verifyToken = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await fetchWithRefreshRestau(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/resto/verify`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        
                    },
                    credentials: 'include',})
                
                const data = await response?.json();
                if (data.success && data.role === 'restaurateur') {
                    setIsAuthorized(true);
                } else {
                    setIsAuthorized(false);
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du token :', error);
                setIsAuthorized(false);
            }
        };

        verifyToken();
    }, []);

    if (isAuthorized === null) {
        return <div>Chargement...</div>;
    }

    if (!isAuthorized) {
        return <Navigate to="*" replace />;
    }
    return <>{children}</>;
};

export default ProtectedRoadResto;

